<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Admin Users</h5>
                <div v-if="userdatadisplayflag && host_id == ''">
                    <Button label="Create User" @click="openCreateUserPopUp()"></Button>
                </div>
            </div>
            <div class="card">
                <div class="p-d-flex p-ai-center p-flex-column p-flex-lg-row p-mb-1">
                    <div class="p-d-flex p-mr-3">
                        <Dropdown v-model="emp_name" :options="adminList" @change="getAdminEmpDetails($event)"
                            optionLabel="label" appendTo="body" class="p-text-capitalize" placeholder="Select admin"
                            :style="{ minWidth: '200px' }" />
                    </div>
                    <!-- <div class="p-d-flex p-mr-3">
                        <Dropdown v-model="host_name" :options="hostList" @change="getHostEmpDetails($event)"
                            optionLabel="label" appendTo="body" class="p-text-capitalize" placeholder="Select host"
                            :style="{ minWidth: '200px' }" />
                    </div>
                    <div class="p-d-flex p-mr-3 ">
                        <Dropdown v-model="branch_name" :options="branchList" @change="getHostBranchEmpDetails($event)"
                            optionLabel="label" appendTo="body" class="p-text-capitalize" placeholder="Select branch"
                            :style="{ minWidth: '200px' }" />
                    </div> -->
                </div>
            </div>
        </div>
    </div>
    <TabView v-if="userdatadisplayflag">
        <TabPanel header="User Details">
            <div class="card">
                <DataTable :value="EmpDetailsList" :lazy="true" :paginator="true" :rows="30"
                    :totalRecords="EmpTotalRecords" :loading="loading" @page="onPageChange" class="p-datatable-users"
                    data-key="ad1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    :style="{ 'overflow-wrap': 'break-word' }">
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column header="User Name" headerStyle="width: 34%">
                        <template #body="{ data }">
                            <div class="p-d-flex p-ai-center">
                                <div class="p-mr-3">
                                    <span v-if="data.ad19">
                                        <img :src="getProfileImage(data.ad22)" width="50" height="50"
                                            style="vertical-align: middle; border-radius: 75px" />
                                    </span>
                                    <span v-else>
                                        <img src="/assets/layout/images/widgets/asset-profile-11.png" width="50"
                                            height="50" style="vertical-align: middle; border-radius: 75px" />
                                    </span>
                                </div>
                                <div>
                                    <div class="p-text-capitalize overflow-span">{{ data.ad9 ? data.ad9
                                        : 'N/A' }}</div>
                                </div>
                            </div>
                        </template>
                    </Column>
                    <Column header="Email Id" headerStyle="width: 30%">
                        <template #body="{ data }">
                            <span class="overflow-span">
                                {{ allow_to_display_email_id ? data.ad18 : maskEmail(data.ad18) }}
                            </span>
                        </template>
                    </Column>
                    <Column header=" Contact Number" headerStyle="width: 13%">
                        <template #body="{ data }">
                            <span class="overflow-span" v-if="allow_to_display_mobile_number">
                                {{ data.ad15 ? data.ad15 : "-" }}
                            </span>
                            <span class="overflow-span" v-else>
                                {{ data.ad15 ? maskMobileNumber(data.ad15) : "-" }}

                            </span>
                        </template>
                    </Column>
                    <Column header="Status" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <div class="overflow-span">
                                <span class="user-badge" :class="getStatus(data.ad44).class">
                                    {{ getStatus(data.ad44).label }}
                                </span>
                            </div>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 8%" class="p-text-right"
                        v-if="userdatadisplayflag && host_id == ''">

                        <template #body="{ data }">
                            <div>
                                <span v-if="this.virtualNumberCount != 0 && allow_to_call">
                                    <!-- Signal oprator condition start -->
                                    <button v-if="this.virtualNumberCount == 1"
                                        class="p-button p-component p-button-icon-only p-button-rounded p-button-success p-mr-2"
                                        title="Call" :disabled="callstatus == 1"
                                        @click="CallTrigerOperatorNumber(data.ad1, data.ad15, this.virtualNumberList[0]['value'])">
                                        <i class="pi pi-phone call-btn-color"></i></button>
                                    <!-- Signal oprator condition end -->
                                    <!-- more oprator condition start -->
                                    <button
                                        class="p-button p-component p-button-icon-only p-button-rounded p-button-success p-mr-2"
                                        @click="toggleOperatorCallList(data.ak1, $event)" :disabled="callstatus == 1"
                                        title="Call" v-if="this.virtualNumberCount != 1">
                                        <i class="pi pi-phone call-btn-color"></i></button>
                                    <OverlayPanel :ref="`${data.ak1}`" appendTo="body" id="overlay_panel"
                                        class="custom-overlay-call-btn">
                                        <div class="overlay-reg-label" v-for="opt in virtualNumberList" :key="opt">
                                            <div>
                                                <button class="btn call-trigger-list-btn"
                                                    @click="CallTrigerOperatorNumber(data.ad1, data.ad15, opt.value, $event)">
                                                    <i class="pi pi-phone overlay-icon me-2"
                                                        style="font-size: 11px;"></i> {{
                                                            opt.label }}
                                                </button>
                                            </div>
                                            <Divider class="my-1" />
                                        </div>
                                    </OverlayPanel>
                                </span>
                                <Button icon="pi pi-user-edit" class="p-button-rounded p-button-success p-mr-2"
                                    @click="editAdminUserPopUPOpen(data)" title="Show User Details" />
                            </div>
                        </template>
                    </Column>
                </DataTable>
                <Toast />
            </div>
        </TabPanel>
    </TabView>
    <!-- Add/Update Admin User Dialog starts here -->
    <Dialog v-model:visible="openCreateUserPopUpStatus" :style="{ width: '900px' }" :modal="true" class="p-fluid"
        :header="adminuserid != null ? 'Edit User Details' : 'Create User'">
        <div class="p-pt-2 p-px-3" v-if="userFormStepFirst">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-4">
                    <label for="primobile">
                        Personal Mobile No.
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            +91
                        </span>
                        <InputText :disabled="adminuserid != null" id="primobile" v-model="primobile" autocomplete="off"
                            maxlength="10" @keypress="onlyNumber" @keyup="checkMobileNumber(primobile)" autofocus
                            :class="{ 'p-invalid': submitted && !primobile }" />
                        <!--  -->
                    </div>
                    <small class="p-invalid p-error" v-if="v$.primobile.$error">{{
                        v$.primobile.$errors[0].$message
                    }}</small>
                    <small class="p-invalid p-error" v-if="this.warningMsg != ''">{{
                        this.warningMsg
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-4" v-if="checkMobileAlreadyExist">
                    <label for="officemobile">
                        Official Mobile No.
                    </label>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            +91
                        </span>
                        <InputText id="officemobile" v-model="officemobile" autocomplete="off" maxlength="10"
                            @keypress="onlyNumber" autofocus />
                        <!--  -->
                    </div>
                </div>
            </div>
            <div class="p-fluid p-formgrid p-grid" v-if="checkMobileAlreadyExist">
                <div class="p-field p-col-12 p-md-4">
                    <label for="title">
                        Title
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="title" v-model="title" :options="titleList" required="true"
                        :class="{ 'p-invalid': submitted && !title }" optionLabel="label" placeholder="Select"
                        appendTo="body">
                    </Dropdown>
                    <small class="p-invalid p-error" v-if="v$.title.$error">{{ v$.title.$errors[0].$message }}</small>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label for="userfirstname">
                        First Name
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <InputText id="userfirstname" class="p-text-capitalize" v-model.trim="userfirstname" required="true"
                        maxlength="30" autofocus @keypress="isLetterWithOutSpace($event)"
                        :class="{ 'p-invalid': submitted && !userfirstname }" />
                    <small class="p-invalid p-error" v-if="v$.userfirstname.$error">{{
                        v$.userfirstname.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label for="usermiddlename">
                        Middle Name
                    </label>
                    <InputText id="usermiddlename" class="p-text-capitalize" @keypress="isLetterWithOutSpace($event)"
                        v-model.trim="usermiddlename" maxlength="30" autofocus />
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label for="userlastname">
                        Last Name
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <InputText id="userlastname" class="p-text-capitalize" @keypress="isLetterWithOutSpace($event)"
                        v-model.trim="userlastname" required="true" maxlength="30" autofocus
                        :class="{ 'p-invalid': submitted && !userlastname }" />
                    <small class="p-invalid p-error" v-if="v$.userlastname.$error">{{
                        v$.userlastname.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label for="user-personalemail">
                        Personal Email Id
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <InputText id="user-personalemail" v-model.trim="personalemail" required="true"
                        autocomplete="usremail" maxlength="70" autofocus
                        :class="{ 'p-invalid': submitted && !personalemail }" />
                    <small class="p-invalid p-error" v-if="v$.personalemail.$error">{{
                        v$.personalemail.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label for="user-officeemail">
                        Official Email Id
                    </label>
                    <InputText id="user-officeemail" v-model.trim="officeemail" autocomplete="usremail" maxlength="70"
                        autofocus />
                    <small class="p-invalid p-error" v-if="v$.officeemail.$error">{{
                        v$.officeemail.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Gender <span class="p-invalid p-error"> *</span></label>
                    <div class="p-field-radiobutton">
                        <RadioButton id="Male" name="option" v-bind:value="1" v-model="gender" :checked="gender == 1" />
                        <label for="Male" class="p-mr-2">Male</label>
                        <RadioButton id="Female" name="option" v-bind:value="2" v-model="gender"
                            :checked="gender == 2" />
                        <label for="Female" class="p-mr-2">Female</label>
                        <RadioButton id="Other" name="option" v-bind:value="3" v-model="gender"
                            :checked="gender == 3" />
                        <label for="Other" class="p-mr-2">Other</label>
                    </div>
                    <small class="p-invalid p-error" v-if="v$.gender.$error">{{
                        v$.gender.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label for="dof">
                        Date of Birth
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Calendar :showIcon="true" :monthNavigator="true" :yearNavigator="true" v-model="dob"
                        :maxDate="subdate" placeholder="DD/MM/YYYY" dateFormat="dd/mm/yy" appendTo="body"
                        :manualInput="false" :yearRange="'1950:' + subdate.getFullYear()">
                    </Calendar>
                    <small class="p-invalid p-error" v-if="v$.dob.$error">
                        {{ v$.dob.$errors[0].$message }}
                    </small>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label for="bloodgroup">
                        Blood Group
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="bloodgroup" v-model="bloodgroup" :options="bloodgroupList" optionLabel="label"
                        placeholder="Select Blood Group" :filter="false" appendTo="body">
                    </Dropdown>
                    <small class="p-invalid p-error" v-if="v$.bloodgroup.$error">{{
                        v$.bloodgroup.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label for="state">
                        State
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="state" v-model="state" :options="stateList" optionLabel="label"
                        placeholder="Select State" :filter="true" @change="getDistrictByStateId(state)" appendTo="body">
                    </Dropdown>
                    <small class="p-invalid p-error" v-if="v$.state.$error">{{
                        v$.state.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label for="district">
                        District
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="district" v-model="district" :options="districtList" optionLabel="label"
                        placeholder="Select District" :filter="true" @change="getCityByDistrictId(district)"
                        appendTo="body">
                    </Dropdown>
                    <small class="p-invalid p-error" v-if="v$.district.$error">{{
                        v$.district.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label for="city">
                        City
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="city" v-model="city" :options="cityList" optionLabel="label" placeholder="Select City"
                        :filter="true" @change="getAreaByCityId(city)" appendTo="body"></Dropdown>
                    <small class="p-invalid p-error" v-if="v$.city.$error">{{
                        v$.city.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label for="area">
                        Area
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="area" v-model="area" :options="areaList" optionLabel="label" placeholder="Select Area"
                        :filter="true" @change="onAreaChange($event)" appendTo="body"></Dropdown>
                    <small class="p-invalid p-error" v-if="v$.area.$error">{{
                        v$.area.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-8">
                    <label for="address">
                        Address
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Textarea id="address" v-model="address" :autoResize="true" rows="2" cols="30"
                        placeholder="Enter Full Address" maxlength="250" />
                    <small class="p-invalid p-error" v-if="v$.address.$error">{{
                        v$.address.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label for="pincode">
                        Pin Code
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <div class="p-inputgroup">
                        <InputText id="pincode" v-model="pincode" autocomplete="off" minlength="6" maxlength="6"
                            @keypress="onlyNumber" autofocus :class="{ 'p-invalid': submitted && !pincode }" />
                    </div>
                    <small class="p-invalid p-error" v-if="v$.pincode.$error">{{
                        v$.pincode.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Upload Profile </label>
                    <FileUpload mode="basic" ref="profileImage" accept="image/*" :maxFileSize="1000000"
                        chooseLabel="Upload Profile" auto @select="onSelectProfile">
                    </FileUpload>
                    <span v-if="profileUrl == null">
                        <img v-if="userprofilefile" class="p-pt-2" role="presentation" alt="userprofile87878"
                            :src="getProfileImage(userprofilefile)" width="120" height="120" />
                    </span>
                    <img v-if="profileUrl" class="p-pt-2" role="presentation" :alt="profileUrl.name"
                        :src="profileUrl.url" width="120" height="120" />
                    <small class="p-invalid p-error" v-if="profileImageError">{{ profileImageError }}</small>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label for="userstatus">
                        Select Status
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="userstatus" v-model="userstatus" :options="userstatusList" optionLabel="label"
                        placeholder="Select Status" appendTo="body">
                    </Dropdown>
                    <small class="p-invalid p-error" v-if="v$.userstatus.$error">{{
                        v$.userstatus.$errors[0].$message
                    }}</small>
                </div>
            </div>
        </div>
        <div class="p-pt-2 p-px-3" v-if="userFormStepSecond">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-mb-2">
                    <span class="subtext p-mt-2 p-text-capitalize">
                        <h6>User Permissions</h6>
                    </span>
                </div>
                <div class="p-field p-col-12 p-md-12 p-mb-0">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <div>
                            <label>Allow to display Mobile Number :</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0">
                            <InputSwitch v-model="AllowShowMobileNoPermission" />
                        </div>
                    </div>
                </div>
                <Divider type="dashed" />
                <div class="p-field p-col-12 p-md-12 p-mb-0">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <div>
                            <label>Allow to display Email ID :</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0">
                            <InputSwitch v-model="AllowShowEmailPermission" />
                        </div>
                    </div>
                </div>
                <Divider type="dashed" />
                <div class="p-field p-col-12 p-md-12 p-mb-0">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <div>
                            <label>Allow to modify Law User's Professional Information :</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0">
                            <InputSwitch v-model="AllowShowEditUserBtnPermission" />
                        </div>
                    </div>
                </div>
                <Divider type="dashed" />
                <div class="p-field p-col-12 p-md-12 p-mb-0">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <div>
                            <label>Allow to display Driving License :</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0">
                            <InputSwitch v-model="criticalpermission.allow_to_display_driving_licence_number" />
                        </div>
                    </div>
                </div>
                <Divider type="dashed" />
                <div class="p-field p-col-12 p-md-12 p-mb-0">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <div>
                            <label>Allow to display PAN Number :</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0">
                            <InputSwitch v-model="criticalpermission.allow_to_display_pan_number" />
                        </div>
                    </div>
                </div>
                <Divider type="dashed" />
                <div class="p-field p-col-12 p-md-12 p-mb-0">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <div>
                            <label>Allow to display Passport Number :</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0">
                            <InputSwitch v-model="criticalpermission.allow_to_display_passport_number" />
                        </div>
                    </div>
                </div>
                <Divider type="dashed" />
                <div class="p-field p-col-12 p-md-12 p-mb-0">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <div>
                            <label>Allow to display Voter Number :</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0">
                            <InputSwitch v-model="criticalpermission.allow_to_display_voter_number" />
                        </div>
                    </div>
                </div>
                <Divider type="dashed" />
                <div class="p-field p-col-12 p-md-12 p-mb-0">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <div>
                            <label>Allow to modify Admin User's Professional Information :</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0">
                            <InputSwitch v-model="criticalpermission.edit_admin_user" />
                        </div>
                    </div>
                </div>
                <Divider type="dashed" />
                <div class="p-field p-col-12 p-md-12 p-mb-0">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <div>
                            <label>Allow to display GST Number :</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0">
                            <InputSwitch v-model="criticalpermission.allow_to_display_GST_number" />
                        </div>
                    </div>
                </div>
                <Divider type="dashed" />
                <div class="p-field p-col-12 p-md-12 p-mb-0">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <div>
                            <label>Allow making calls to the Tenant :</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0">
                            <InputSwitch v-model="criticalpermission.allow_to_call_for_tenant" />
                        </div>
                    </div>
                </div>
                <Divider type="dashed" />
                <div class="p-field p-col-12 p-md-12 p-mb-0">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <div>
                            <label>Allow making calls to the Employee :</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0">
                            <InputSwitch v-model="criticalpermission.allow_to_call_for_employee" />
                        </div>
                    </div>
                </div>
                <Divider type="dashed" />
                <div class="p-field p-col-12 p-md-12 p-mb-0">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <div>
                            <label>Allow to display Tenant information :</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0">
                            <InputSwitch v-model="criticalpermission.allow_to_display_tenant_information" />
                        </div>
                    </div>
                </div>
                <Divider type="dashed" />
                <div class="p-field p-col-12 p-md-12 p-mb-0">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <div>
                            <label>Allow displaying Employee information :</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0">
                            <InputSwitch v-model="criticalpermission.allow_to_display_employee_information" />
                        </div>
                    </div>
                </div>

                <Divider type="dashed" />
                <div class="p-field p-col-12 p-md-12 p-mb-0">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <div>
                            <label>Allow listening to Tenant call recordings :</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0">
                            <InputSwitch v-model="criticalpermission.allow_to_listen_tenant_call_recording" />
                        </div>
                    </div>
                </div>
                <Divider type="dashed" />
                <div class="p-field p-col-12 p-md-12 p-mb-0">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <div>
                            <label>Allow listening to Employee call recordings :</label>
                        </div>
                        <div class="p-field-radiobutton p-mb-0">
                            <InputSwitch v-model="criticalpermission.allow_to_listen_employee_call_recording" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-pt-2 p-px-3" v-if="userFormStepThird">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-mb-2">
                    <span class="subtext p-mt-2 p-text-capitalize">
                        <h6>Menus Permissions</h6>
                    </span>
                </div>
            </div>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-12">
                    <Tree :value="nodes" selectionMode="checkbox" v-model:selectionKeys="selectedTreeValue"
                        :expandedKeys="expandedKeys" class="custom-users-role">
                    </Tree>
                </div>
            </div>
        </div>
        <template #footer v-if="userFormStepFirst">
            <Button v-show="!showLoader" :label="adminuserid != null ? 'Next' : 'Next'" icon="pi pi-check"
                class="p-button-text p-ml-auto" @click="createUpdateAdminUser" style="width: 90px;"></Button>
            <Button v-show="showLoader" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
                style="width: 90px"></Button>
        </template>
        <template #footer v-else-if="userFormStepSecond">
            <Button v-show="!showLoader" :label="adminuserid != null ? 'Next' : 'Next'" icon="pi pi-check"
                class="p-button-text p-ml-auto" @click="createUpdateAdminPermission" style="width: 90px;"></Button>
            <Button v-show="showLoader" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
                style="width: 90px"></Button>
        </template>
        <template #footer v-else-if="userFormStepThird">
            <Button v-show="!showLoader" :label="adminuserid != null ? 'Update' : 'Create'" icon="pi pi-check"
                class="p-button-text p-ml-auto" @click="updateAdminMenuPermissions" style="width: 90px;"></Button>
            <Button v-show="showLoader" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
                style="width: 90px"></Button>
        </template>
    </Dialog>
    <!-- Add/Update Admin User Dialog end here -->
</template>
<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import CommonMixins from '../../mixins/common-mixins';
import { required, alpha, helpers, minLength, maxLength, numeric, email } from '@vuelidate/validators';
import moment from 'moment';

export default {
    mixins: [CommonMixins],
    data() {
        return {
            v$: useValidate(),
            adminList: [],
            hostList: [],
            branchList: [],
            page_no: 0,
            EmpTotalRecords: 0,
            loading: false,
            EmpDetailsList: [],
            emp_name: '',
            host_name: '',
            branch_name: '',
            userdatadisplayflag: false,
            admin_id: '',
            host_id: '',
            branch_id: '',
            admin_list_status: false,
            host_list_status: false,
            branch_list_status: false,
            itemsPerPage: 30,
            openCreateUserPopUpStatus: false,
            title: { label: "Mr.", value: 1 },
            titleList: [],
            userfirstname: '',
            usermiddlename: '',
            userlastname: '',
            primobile: '',
            officemobile: '',
            personalemail: '',
            officeemail: '',
            gender: '',
            stateList: [],
            districtList: [],
            cityList: [],
            areaList: [],
            state: '',
            district: '',
            city: '',
            area: '',
            address: '',
            pincode: '',
            bloodgroup: '',
            bloodgroupList: [],
            userstatus: null,
            userstatusList: [
                { label: "Active", value: 1 },
                { label: "Temporary Suspended", value: 2 },
                { label: "Permanent Suspended", value: 3 }
            ],
            profileUrl: null,
            profileImage: null,
            profileImageError: '',
            userprofilefile: null,
            dob: '',
            todaysDate: new Date(),
            checkMobileAlreadyExist: false,
            submitted: false,
            showLoader: false,
            stateID: 0,
            warningMsg: '',
            adminuserid: null,
            // subdate: this.subtractYears(new Date(), 16),
            subdate: moment().subtract(20, "years")._d,
            roles: null,
            virtualNumberCount: 0,
            virtualNumberList: [],
            callstatus: 0,
            allow_to_display_mobile_number: 0,
            allow_to_display_email_id: 0,
            allow_to_call: 0,
            userFormStepFirst: false,
            userFormStepSecond: false,
            userFormStepThird: false,
            AllowShowMobileNoPermission: false,
            AllowShowEmailPermission: false,
            AllowShowEditUserBtnPermission: false,
            criticalpermission: {
                allow_to_display_driving_licence_number: false,
                allow_to_display_pan_number: false,
                allow_to_display_passport_number: false,
                allow_to_display_voter_number: false,
                edit_admin_user: false,
                allow_to_display_GST_number: false,
                allow_to_call_for_tenant: false,
                allow_to_call_for_employee: false,
                allow_to_display_tenant_information: false,
                allow_to_display_employee_information: false,
                allow_to_listen_tenant_call_recording: false,
                allow_to_listen_employee_call_recording: false,
            },
            nodes: [],
            expandedKeys: [],
            selectedTreeValue: [],
            clientBucketName: '',
            userProfileFolder: '',
            storagePublicPath: '',
            isProduction: '',
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    computed: {
        getStatus() {
            return (status) => {
                const map = {
                    1: { label: 'Active', class: 'status-active' },
                    2: { label: 'Temporary Suspended', class: 'status-temp-suspend' },
                    3: { label: 'Permanently Suspended', class: 'status-per-suspend' },
                    4: { label: 'In Process', class: 'status-in-process' },
                    5: { label: 'In Progress', class: 'status-in-progress' },
                    6: { label: 'Suspicious', class: 'status-suspicious' }
                };

                return map[status] || { label: 'Unknown', class: 'status-unknown' };
            };
        }
    },
    mounted() {
        this.userstatus = this.userstatusList[0];
        this.getAdminListOnly();
        this.getTitles();
        this.getStates();
        this.getbloodgroups();
        this.getcallbacknumbers();


        const localdata = JSON.parse(localStorage.user);
        this.allow_to_display_mobile_number = localdata.allow_to_display_mobile_number;
        this.allow_to_display_email_id = localdata.allow_to_display_email_id;
        this.allow_to_call = localdata.allow_to_call;
        this.isProduction = process.env.NODE_ENV === 'production';
    },
    validations() {
        let validation = {
            title: { required: helpers.withMessage('Please select title', required) },
            userfirstname: { required: helpers.withMessage('Please enter first name', required), alpha: helpers.withMessage('Please input alphabet characters only', alpha) },
            userlastname: { required: helpers.withMessage('Please enter last name', required), alpha: helpers.withMessage('Please input alphabet characters only', alpha) },
            primobile: { required: helpers.withMessage('Please enter mobile number', required), numeric: helpers.withMessage('Only numbers are allowed', numeric), minLength: minLength(10), maxLength: maxLength(10) },
            personalemail: { required: helpers.withMessage('Please enter email id', required), email: helpers.withMessage('Email id is invalid', email) },
            officeemail: { email: helpers.withMessage('Email id is invalid', email) },
            gender: { required: helpers.withMessage('Please select gender', required) },
            pincode: { required: helpers.withMessage('Please enter pin code', required) },
            bloodgroup: { required: helpers.withMessage('Please select blood group', required) },
            state: { required: helpers.withMessage('Please select state', required) },
            district: { required: helpers.withMessage('Please select district', required) },
            city: { required: helpers.withMessage('Please select city', required) },
            area: { required: helpers.withMessage('Please select area', required) },
            address: { required: helpers.withMessage('Please enter address', required) },
            dob: { required: helpers.withMessage('Please enter date of birth', required) },
            userstatus: { required: helpers.withMessage('Please select status', required) },
        };
        return validation;
    },
    methods: {

        getEmail(val) {
            return this.allow_to_display_email_id ? val : this.maskEmail(val)
        },
        CallTrigerOperatorNumber(adminUserId, mobileno, settingid, event) {
            setTimeout(() => {
                this.$refs[adminUserId].hide(event);
            }, 1000);
            this.ApiService.triggercalltovisitorconnect({ adminUserId: adminUserId, mobile_number: mobileno, settingId: settingid, adminId: this.admin_id }).then(
                (items) => {
                    if (items.success === true) {
                        this.callstatus = 0;
                        var successMsg = items.message;
                        this.$toast.open({
                            message: successMsg,
                            type: "success",
                            duration: 3000,
                            position: "top-right",
                        });
                    } else {
                        var errorMsg = items.message;
                        this.$toast.open({
                            message: errorMsg,
                            type: "error",
                            duration: 3000,
                            position: "top-right",
                        });
                        this.callstatus = 0;
                    }
                }
            );
        },
        getcallbacknumbers(e) {
            this.ApiService.getcallbacknumbers(e).then((data) => {
                if (data.success == true) {
                    this.virtualNumberList = data.records;
                    this.virtualNumberCount = data.count;
                }
            });
        },
        getAssignedRoles(val) {
            if (val != '' && val != null && val != '0') {
                var res1 = val.split(',').map(Number);
                var res = Array.from(res1);
                let array = [];
                for (let i = 0; i < res.length; i++) {
                    for (let j = 0; j < this.roles.length; j++) {
                        if (this.roles[j].value == res[i]) {
                            array.push(this.roles[j].label);
                        }
                    }
                }
                return array.join(",");
            }
        },

        subtractYears(date, years) {
            date.setFullYear(date.getFullYear() - years);
            return date;
        },

        getAdminListOnly() {
            this.ApiService.getAdminListOnly().then((data) => {
                if (data.status == 200) {
                    this.adminList = data.data.records;
                    if (data.data.records.length == 1) {
                        const adminvalue = data.data.records[0];
                        this.getAdminEmpDetails(adminvalue);
                        this.emp_name = data.data.records[0];
                    }
                } else {
                    this.adminList = null;
                }
            });
        },

        getTitles(e) {
            this.ApiService.getTitles(e).then((data) => {
                if (data.status == 200) {
                    this.titleList = data.data;
                } else {
                    this.titleList = null;
                }
            });
        },
        getbloodgroups(e) {
            this.ApiService.getbloodgroups(e).then((data) => {
                if (data.status == 200) {
                    this.bloodgroupList = data.data;
                } else {
                    this.bloodgroupList = null;
                }
            });
        },
        getAdminEmpDetails(e) {
            this.userdatadisplayflag = true;
            this.loading = true;
            if (e) {
                this.stateID = e.maa8;
                this.getDistrictByStateId({ value: e.maa8 });
                this.page_no = 0;
                this.admin_id = e.value; // e.value is likely the admin's ID
            }
            this.checkMobileAlreadyExist = false;
            this.ApiService.getAllAdminUserDetails({ clientId: this.admin_id, page_no: this.page_no, itemsPerPage: this.itemsPerPage }).then((data) => {
                if (data.success === true) {
                    this.EmpDetailsList = data.data;
                    this.EmpTotalRecords = data.count;
                    this.loading = false;
                    this.admin_list_status = true;
                    this.host_name = '';
                    this.host_id = '';
                    this.branch_name = '';
                    this.clientBucketName = data.clientBucketName;
                    this.userProfileFolder = data.userProfileFolder;
                    this.storagePublicPath = data.storagePublicPath;
                }
            });
        },
        getProfileImage(file) {
            if (!file) return '';

            const base = this.storagePublicPath || '';
            const folder = this.userProfileFolder || '';
            const bucket = this.clientBucketName || '';

            // Local
            if (!this.isProduction) {
                return `${base}${bucket}/${folder}/${file}`;
            }

            // Production
            return `${base}${folder}/${file}`;
        },
        onPageChange(e) {
            this.loading = true;
            if (this.admin_list_status) {
                this.page_no = e.page;
                this.getAdminEmpDetails();
            }
            // if (this.host_list_status) {
            //     this.page_no = e.page;
            //     this.getHostEmpDetails();
            // }
            // if (this.branch_list_status) {
            //     this.page_no = e.page;
            //     this.getHostBranchEmpDetails();
            // }
        },

        // getHostListOnly(e) {
        //     this.ApiService.getHostListOnly({ clientId: e.value.value }).then((data) => {
        //         if (data.status == 200) {
        //             this.hostList = data.data.records;
        //         } else {
        //             this.hostList = null;
        //         }
        //     });
        // },

        // getHostEmpDetails(e) {
        //     this.loading = true;
        //     if (e) {
        //         this.page_no = 0;
        //         this.host_id = e.value.value;
        //     }
        //     this.ApiService.getHostUserDetails({ clientId: this.admin_id, hostId: this.host_id, page_no: this.page_no, itemsPerPage: this.itemsPerPage }).then((data) => {
        //         if (data.success === true) {
        //             this.EmpDetailsList = data.data;
        //             this.EmpTotalRecords = data.count;
        //             this.loading = false;
        //             this.userdatadisplayflag = true;
        //             this.admin_list_status = false;
        //             this.host_list_status = true;
        //             this.branch_name = '';
        //             if (e) {
        //                 this.getHostBranchListOnly(e);
        //             }
        //         }
        //     });
        // },

        // getHostBranchListOnly(e) {
        //     this.host_id = e.value.value;
        //     this.ApiService.getHostBranchesOnly({ clientId: this.admin_id, hostId: e.value.value }).then((data) => {
        //         if (data.status == 200) {
        //             this.branchList = data.data;
        //         } else {
        //             this.branchList = null;
        //         }
        //     });
        // },

        // getHostBranchEmpDetails(e) {
        //     if (e) {
        //         this.page_no = 0;
        //         this.branch_id = e.value.value;
        //     }
        //     this.loading = true;
        //     this.ApiService.getHostBranchesUserDetails({ clientId: this.admin_id, hostId: this.host_id, branchId: this.branch_id, page_no: this.page_no, itemsPerPage: this.itemsPerPage }).then((data) => {
        //         if (data.success === true) {
        //             this.EmpDetailsList = data.data.result;
        //             this.EmpTotalRecords = data.data.count;
        //             this.loading = false;
        //             this.userdatadisplayflag = true;
        //         }
        //     });
        // },

        onAreaChange(e) {
            this.pincode = e.value.mam4;
        },

        async onSelectProfile(e) {
            this.profileImage = e.files[0];
            const file = e.files[0];
            let allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
            if (file.size > 2 * 1024 * 1024) {
                this.profileImageError = 'File size cannot exceed more than 2MB';
                this.profileImage = null;
            } else if (!file.name.match(allowedExtensions)) {
                this.profileImageError = 'Invalid file type';
                this.profileImage = '';
            } else {
                this.profileImageError = '';
                if (file && file.type.includes('image/')) {
                    this.profileUrl = { url: file.objectURL, name: file.name };
                    this.profileImage = e.files[0];
                } else {
                    this.profileImageError = 'Invalid file type';
                    this.profileImage = '';
                }
            }
        },

        async openCreateUserPopUp() {
            this.adminuserid = null;
            this.userfirstname = '';
            this.usermiddlename = '';
            this.userlastname = '';
            this.primobile = '';
            this.officemobile = '';
            this.personalemail = '';
            this.officeemail = '';
            this.gender = '';
            this.state = '';
            this.district = '';
            this.city = '';
            this.area = '';
            this.address = '';
            this.pincode = '';
            this.bloodgroup = '';
            this.profileUrl = null;
            this.profileImage = null;
            this.profileImageError = '';
            this.userprofilefile = null;
            this.dob = '';
            this.checkMobileAlreadyExist = false;
            this.warningMsg = '';
            var res = Number(this.stateID);
            this.userFormStepFirst = true;
            this.userFormStepSecond = false;
            this.userFormStepThird = false;
            this.openCreateUserPopUpStatus = true;
            this.AllowShowMobileNoPermission = false,
                this.AllowShowEmailPermission = false,
                this.AllowShowEditUserBtnPermission = false,
                this.criticalpermission = {
                    allow_to_display_driving_licence_number: false,
                    allow_to_display_pan_number: false,
                    allow_to_display_passport_number: false,
                    allow_to_display_voter_number: false,
                    edit_admin_user: false,
                    allow_to_display_GST_number: false,
                    allow_to_call_for_tenant: false,
                    allow_to_call_for_employee: false,
                    allow_to_display_tenant_information: false,
                    allow_to_display_employee_information: false,
                    allow_to_listen_tenant_call_recording: false,
                    allow_to_listen_employee_call_recording: false,
                };
            let data = this.stateList.filter(function (item) {
                return item.value == res;
            });
            if (this.stateID) {
                await this.getDistrictByStateId({ value: this.stateID })
            }
            if (this.emp_name) {
                await this.getApprovedAdminMenus({ maa1: this.emp_name.value });
            }
            if (data.length > 0) {
                this.state = data[0];
            }
        },

        async checkMobileNumber(e) {
            if (e.length >= 10) {
                this.showLoader = true;
                this.warningMsg = '';

                try {
                    const data = await this.ApiService.checkUserMobileisAlreadyPresent({
                        clientId: this.admin_id,
                        mobileNumber: e
                    });

                    if (data.status === 200) {
                        this.warningMsg = data.message;
                        this.checkMobileAlreadyExist = false;
                    } else {
                        this.checkMobileAlreadyExist = true;
                        this.warningMsg = '';
                    }
                } catch (error) {
                    this.checkMobileAlreadyExist = false;
                } finally {
                    this.showLoader = false;
                }
            }
        },
        async editAdminUserPopUPOpen(data) {
            this.userfirstname = '';
            this.usermiddlename = '';
            this.userlastname = '';
            this.primobile = '';
            this.officemobile = '';
            this.personalemail = '';
            this.officeemail = '';
            this.gender = '';
            this.state = '';
            this.district = '';
            this.city = '';
            this.area = '';
            this.address = '';
            this.pincode = '';
            this.bloodgroup = '';
            this.profileUrl = null;
            this.profileImage = null;
            this.profileImageError = '';
            this.userprofilefile = null;
            this.dob = '';
            this.AllowShowMobileNoPermission = false,
                this.AllowShowEmailPermission = false,
                this.AllowShowEditUserBtnPermission = false,
                this.criticalpermission = {};
            

            this.userFormStepFirst = true;
            this.userFormStepSecond = false;
            this.userFormStepThird = false;
            this.openCreateUserPopUpStatus = true;
            this.checkMobileAlreadyExist = true;
            this.adminuserid = data.ad1;
            this.title = this.titleList.find((item) => item.value == data.ad4)
            this.userfirstname = data.ad6;
            this.usermiddlename = data.ad7;
            this.userlastname = data.ad8;
            this.primobile = data.ad15;
            this.officemobile = data.ad21;
            this.personalemail = data.ad18;
            this.officeemail = data.ad51
            this.gender = data.ad14;
            this.address = data.ad30;
            this.pincode = data.ad37;
            this.bloodgroup = this.bloodgroupList.find((item) => item.value == data.ad76)
            this.userstatus =
                data.ad44 == 1
                    ? { value: 1, label: "Active" }
                    : data.ad44 == 2
                        ? { value: 2, label: "Temporary Suspended" }
                        : data.ad44 == 3
                            ? { value: 3, label: "Permanent Suspended" }
                            : { value: 1, label: "Active" };

            if (data.ad12 != null && data.ad12 != "0000-00-00") {
                this.dob = new Date(data.ad12);
            }
            this.userprofilefile = data.ad22;
            if (data.ad39 == 1) {
                this.AllowShowMobileNoPermission = true;
            } else {
                this.AllowShowMobileNoPermission = false;
            }
            if (data.ad40 == 1) {
                this.AllowShowEmailPermission = true;
            } else {
                this.AllowShowEmailPermission = false;
            }
            if (data.ad42 == 1) {
                this.AllowShowEditUserBtnPermission = true;
            } else {
                this.AllowShowEditUserBtnPermission = false;
            }
            let ad145 = {};
            try {
                ad145 = JSON.parse(data.ad145 || '{}');
            } catch (e) {
                ad145 = {};
            }
            this.criticalpermission = {
                allow_to_display_driving_licence_number: ad145.allow_to_display_driving_licence_number === 1,
                allow_to_display_pan_number: ad145.allow_to_display_pan_number === 1,
                allow_to_display_passport_number: ad145.allow_to_display_passport_number === 1,
                allow_to_display_voter_number: ad145.allow_to_display_voter_number === 1,
                edit_admin_user: ad145.edit_admin_user === 1,
                allow_to_display_GST_number: ad145.allow_to_display_GST_number === 1,
                allow_to_call_for_tenant: ad145.allow_to_call_for_tenant === 1,
                allow_to_call_for_employee: ad145.allow_to_call_for_employee === 1,
                allow_to_display_tenant_information: ad145.allow_to_display_tenant_information === 1,
                allow_to_display_employee_information: ad145.allow_to_display_employee_information === 1,
                allow_to_listen_tenant_call_recording: ad145.allow_to_listen_tenant_call_recording === 1,
                allow_to_listen_employee_call_recording: ad145.allow_to_listen_employee_call_recording === 1,
            };
            this.selectedTreeValue = [];
            if (data.ad28 != null) {
                let arrConverted = data.ad28.split(",");
                this.selectedTreeValue = {};
                for (let index = 0; index < arrConverted.length; index++) {
                    let idxx = parseInt(arrConverted[index]); // Ensure the key is treated as an integer
                    this.selectedTreeValue[idxx] = { checked: true, partialChecked: false };
                }
            }
            await this.getDistrictByStateId({ value: data.ad35 });
            await this.getCityByDistrictId({ value: data.ad99 });
            await this.getAreaByCityId({ value: data.ad33 });
            if (this.emp_name) {
                await this.getApprovedAdminMenus({ maa1: this.emp_name.value });
            }
            this.state = this.stateList.find(item => item.value == data.ad35);
            this.district = this.districtList.find(item => item.value == data.ad99);
            this.city = this.cityList.find(item => item.value == data.ad33);
            this.area = this.areaList.find(item => item.value == data.ad31);
        },
        createUpdateAdminUser() {
            this.submitted = true;
            this.v$.$validate();
            let formData = new FormData();
            if (this.adminuserid != null) {
                formData.append('ad1', this.adminuserid);
            }
            formData.append('clientId', this.admin_id);
            formData.append('ad4', this.title.value);
            formData.append('ad5', this.title.label);
            formData.append('ad6', this.userfirstname);
            if (this.usermiddlename) {
                formData.append('ad7', this.usermiddlename);
            }
            formData.append('ad8', this.userlastname);
            formData.append('ad12', moment(this.dob).format('YYYY-MM-DD'));
            formData.append('ad14', this.gender);
            formData.append('ad15', this.primobile);
            if (this.officemobile) {
                formData.append('ad21', this.officemobile);
            }
            formData.append('ad18', this.personalemail);
            if (this.officeemail) {
                formData.append('ad51', this.officeemail);
            }

            if (this.profileImage) {
                formData.append('ad22', this.profileImage);
            }
            formData.append('ad30', this.address);
            formData.append('ad31', this.area.value);
            formData.append('ad32', this.area.label);
            formData.append('ad33', this.city.value);
            formData.append('ad34', this.city.label);
            formData.append('ad35', this.state.value);
            formData.append('ad36', this.state.label);
            formData.append('ad99', this.district.value);
            formData.append('ad100', this.district.label);
            formData.append('ad37', this.pincode);
            if (this.bloodgroup) {
                formData.append("ad76", this.bloodgroup.value);
                formData.append("ad77", this.bloodgroup.label);
            }
            formData.append("ad44", this.userstatus.value);
            if (!this.v$.$error) {
                this.showLoader = true;
                this.ApiService.createUpdateAdminUsers(formData).then((items) => {
                    if (items.success) {
                        this.adminuserid = items.data.ad1;
                        this.showLoader = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.userFormStepFirst = false;
                        this.userFormStepSecond = true;
                        this.userFormStepThird = false
                    } else {
                        this.userFormStepFirst = true;
                        this.userFormStepSecond = false;
                        this.userFormStepThird = false;
                        this.showLoader = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        createUpdateAdminPermission() {
            this.submitted = true;
            let formData = new FormData();
            if (this.adminuserid != null) {
                formData.append('ad1', this.adminuserid);
            }
            formData.append('clientId', this.admin_id);
            formData.append('ad4', this.title.value);
            formData.append('ad5', this.title.label);
            formData.append('ad6', this.userfirstname);
            if (this.usermiddlename) {
                formData.append('ad7', this.usermiddlename);
            }
            formData.append('ad8', this.userlastname);
            formData.append('ad12', moment(this.dob).format('YYYY-MM-DD'));
            formData.append('ad14', this.gender);
            formData.append('ad15', this.primobile);
            if (this.officemobile) {
                formData.append('ad21', this.officemobile);
            }
            formData.append('ad18', this.personalemail);
            if (this.officeemail) {
                formData.append('ad51', this.officeemail);
            }

            if (this.profileImage) {
                formData.append('ad22', this.profileImage);
            }
            formData.append('ad30', this.address);
            formData.append('ad31', this.area.value);
            formData.append('ad32', this.area.label);
            formData.append('ad33', this.city.value);
            formData.append('ad34', this.city.label);
            formData.append('ad35', this.state.value);
            formData.append('ad36', this.state.label);
            formData.append('ad99', this.district.value);
            formData.append('ad100', this.district.label);
            formData.append('ad37', this.pincode);
            if (this.bloodgroup) {
                formData.append("ad76", this.bloodgroup.value);
                formData.append("ad77", this.bloodgroup.label);
            }
            formData.append("ad44", this.userstatus.value);
            // permission allow
            if (this.AllowShowMobileNoPermission == true) {
                formData.append("ad39", 1);
            } else if (this.AllowShowMobileNoPermission == false) {
                formData.append("ad39", 0);
            }
            if (this.AllowShowEmailPermission == true) {
                formData.append("ad40", 1);
            } else if (this.AllowShowEmailPermission == false) {
                formData.append("ad40", 0);
            }
            if (this.AllowShowEditUserBtnPermission == true) {
                formData.append("ad42", 1);
            } else if (this.AllowShowEditUserBtnPermission == false) {
                formData.append("ad42", 0);
            }
            const payload = {
                allow_to_display_driving_licence_number: this.criticalpermission.allow_to_display_driving_licence_number ? 1 : 0,
                allow_to_display_pan_number: this.criticalpermission.allow_to_display_pan_number ? 1 : 0,
                allow_to_display_passport_number: this.criticalpermission.allow_to_display_passport_number ? 1 : 0,
                allow_to_display_voter_number: this.criticalpermission.allow_to_display_voter_number ? 1 : 0,
                edit_admin_user: this.criticalpermission.edit_admin_user ? 1 : 0,
                allow_to_display_GST_number: this.criticalpermission.allow_to_display_GST_number ? 1 : 0,
                allow_to_call_for_tenant: this.criticalpermission.allow_to_call_for_tenant ? 1 : 0,
                allow_to_call_for_employee: this.criticalpermission.allow_to_call_for_employee ? 1 : 0,
                allow_to_display_tenant_information: this.criticalpermission.allow_to_display_tenant_information ? 1 : 0,
                allow_to_display_employee_information: this.criticalpermission.allow_to_display_employee_information ? 1 : 0,
                allow_to_listen_tenant_call_recording: this.criticalpermission.allow_to_listen_tenant_call_recording ? 1 : 0,
                allow_to_listen_employee_call_recording: this.criticalpermission.allow_to_listen_employee_call_recording ? 1 : 0,
            };
            formData.append("ad145", JSON.stringify(payload));
            this.showLoader = true;
            this.ApiService.createUpdateAdminUsers(formData).then((items) => {
                if (items.success) {
                    this.showLoader = false;
                    var successMsg = items.message;
                    this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                    this.userFormStepFirst = false;
                    this.userFormStepSecond = false;
                    this.userFormStepThird = true;

                } else {
                    this.userFormStepFirst = false;
                    this.userFormStepSecond = true;
                    this.userFormStepThird = false;
                    this.showLoader = false;
                    var errorMsg = items.message;
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                }
            });
        },
        updateAdminMenuPermissions() {
            var result = Object.keys(this.selectedTreeValue).map((key) => [
                this.selectedTreeValue[key],
            ]);
            var module_key = [];
            for (let a = 0; a < result.length; a++) {
                for (let i = 0; i < result[a].length; i++) {
                    if (result[a][i]["key"] != undefined) {
                        module_key.push(result[a][i]["key"]);
                    }
                }
            }
            this.submitted = true;
            var formData = new FormData();
            formData.append("ad1", this.adminuserid);
            formData.append("ad28", JSON.stringify(this.selectedTreeValue));
            formData.append('maa1', this.admin_id);
            if (!this.v$.$error) {
                this.showLoader = true;
                this.ApiService.updateClientAdminUserPermission(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoader = false;
                        var successMsg = items.message;
                        this.addUserDialogStatus = false;
                        this.$toast.add({
                            severity: "success",
                            summary: "Successful",
                            detail: successMsg,
                            life: 3000,
                        });
                        this.openCreateUserPopUpStatus = false;
                        this.userFormStepFirst = false;
                        this.userFormStepSecond = false;
                        this.userFormStepThird = false;
                        setTimeout(() => {
                            this.v$.$reset();
                        }, 0);
                        this.ApiService.getAllAdminUserDetails({ clientId: this.admin_id, page_no: this.page_no, itemsPerPage: this.itemsPerPage }).then((data) => {
                            if (data.success === true) {
                                this.EmpDetailsList = data.data;
                                this.EmpTotalRecords = data.count;
                                this.loading = false;
                                this.admin_list_status = true;
                                this.host_name = '';
                                this.host_id = '';
                                this.branch_name = '';
                                this.clientBucketName = data.clientBucketName;
                                this.userProfileFolder = data.userProfileFolder;
                                this.storagePublicPath = data.storagePublicPath;
                            }
                        });
                    } else {
                        this.openCreateUserPopUpStatus = true;
                        this.userFormStepFirst = false;
                        this.userFormStepSecond = false;
                        this.userFormStepThird = true;
                        this.showLoader = false;
                        var errorMsg = items.message;
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: errorMsg,
                            life: 3000,
                        });
                    }
                });
            }
        },
        getStates(ev) {
            this.ApiService.getStates(ev).then((items) => {
                if (items.success === true) {
                    this.stateList = items.data;
                } else {
                    this.stateList = [];
                }
            });
        },
        async getDistrictByStateId(e) {
            var state_id = e.value || e.maa8;
            this.clearstatevalue();
            this.districtloaderflag = true;

            try {
                const data = await this.ApiService.getDistricts({ state_id });

                if (data.success == true) {
                    this.districtList = data.data;
                }
            } finally {
                this.districtloaderflag = false;
            }
        },
        async getCityByDistrictId(e) {
            this.cleardistrictvalue();
            this.cityloaderflag = true;

            try {
                const data = await this.ApiService.getCities({ district_id: e.value });

                if (data.success == true) {
                    this.cityList = data.data;
                } else {
                    this.cityList = [];
                }
            } finally {
                this.cityloaderflag = false;
            }
        },

        async getAreaByCityId(e) {
            this.clearcityvalue();
            this.arealoaderflag = true;

            try {
                const data = await this.ApiService.getAreaList({ city_id: e.value });

                if (data.success == true) {
                    this.areaList = data.data;
                } else {
                    this.areaList = [];
                }
            } finally {
                this.arealoaderflag = false;
            }
        },
        async getApprovedAdminMenus(e) {
            try {
                const data = await this.ApiService.getApprovedAdminMenus(e);

                if (data.success == true) {
                    this.nodes = data.data;
                } else {
                    this.nodes = [];
                }
            } finally {
                this.loading = false;
            }
        },
        clearstatevalue() {
            this.district = "";
            this.city = "";
            this.area = "";
            this.districtList = [];
            this.areaList = [];
            this.cityList = [];
        },
        cleardistrictvalue() {
            this.city = "";
            this.area = "";
            this.areaList = [];
            this.cityList = [];
        },
        clearcityvalue() {
            this.area = "";
            this.areaList = [];
        },
    },
};
</script>
<style scoped lang="scss">
.createbtn {
    text-transform: uppercase;
    margin-left: 380px;
}

.user-badge {
    border-radius: 2px;
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.3px;

    &.status-active {
        background: #c8e6c9;
        color: #256029;
    }

    &.status-per-suspend {
        background: #ffcdd2;
        color: #c63737;
    }

    &.status-temp-suspend {
        background: #ffd8b2;
        color: #805b36;
    }

    &.status-in-process {
        background: #ffd8b2;
        color: #805b36;
    }

    &.status-in-progress {
        background: #ffd8b2;
        color: #805b36;
    }

    &.status-suspicious {
        background: #ffcdd2;
        color: #c63737;
    }
}
</style>
